<template>
  <div
    class="user-info-container"
  >
    <el-popover
      placement="left-start"
      width="max-context"
      trigger="click"
      popper-class="user-info-popover"
    >
      <template #default>
        <div class="user-name">当前账户：{{ userName }}</div>
        <!-- <span class="days-Remaining">账户剩余{{ remainingDays || 0 }}天</span> <br> -->
        <!-- <div class="function-box">
          <svg-icon iconName="user-info-calendar"></svg-icon>
          <div class="function-name">账户剩余期限</div>
          <div class="function-day">
            {{ remainingDays || 0 }}天
          </div>
        </div> -->
        <div class="function-box" @click="toUserCenter" v-if="roleNameFlag">
          <svg-icon iconName="ph--user-bold" fillColor="#000"></svg-icon>
          <div class="function-name">个人中心</div>
        </div>
        <div class="function-box" @click="updateUtil['funItem'].showFlagChange(true)">
          <svg-icon iconName="user-info-password"></svg-icon>
          <div class="function-name">修改密码</div>

        </div>
        <ThemeToggle v-if="ThemeToggleShow" />
        <br v-if="ThemeToggleShow" />
        <!-- <el-button
          text
          type="primary"
          size="small"
          @click="toUserCenter"
          v-if="centerShow"
        >
          个人中心
        </el-button>
        <br v-if="centerShow" />
        <el-button
          text
          type="primary"
          size="small"
          @click="updateUtil['funItem'].showFlagChange(true)"
          v-if="updatePwdShow"
        >
          修改密码
        </el-button>
        <br v-if="updatePwdShow" /> -->
        <el-button
          type="danger"
          @click="loginOut"
          round
        >
          退出登录
        </el-button>
      </template>
      <template #reference>
        <svg-icon
          iconName="ph--user-bold"
          fillColor="#000"
        ></svg-icon>
      </template>
    </el-popover>
    <teleport to="#app" v-if="updateUtil.showFlag">
      <EditCom
        title="修改密码"
        :target="updateUtil.target"
        :buttonList="updateUtil.buttonList"
        :inputList="updateUtil.inputList"
        :rules="updateUtil.rules"
        @closeFun="updateUtil['funItem'].close"
      />
    </teleport>
  </div>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';
import router from '@/router';
import ThemeToggle from '@/components/ThemeToggle';
import EditCom from '@/components/EditCom';
import SvgIcon from '@/components/SvgIcon' 
// props
const props = defineProps({
  centerShow: { type: Boolean, default: ()=> false, },
  ThemeToggleShow: { type: Boolean, default: ()=> false, },
  updatePwdShow: { type: Boolean, default: ()=> false, }
});
// emit
const emit = defineEmits([

]);

const roleNameFlag = computed(()=> store.getters['isSuperAdmin']);

const loginOut = ()=>{
  store.dispatch('loginOut').then(handleLogout)
}
const handleLogout = () => {
  sessionStorage.removeItem('eventlist')
  sessionStorage.removeItem('listQuery')
}
const UserCenterURL = store.getters['permissions/getUserCenterURL'];
const userName = localStorage.getItem('userName');
const remainingDays = localStorage.getItem('remainingDays')
const toUserCenter = ()=>{
  router.push(UserCenterURL);
}

import updateUtil from './utils/updatePaw';
const updateUtilSubmit = updateUtil['funItem'].submit;
updateUtil['funItem'].submit = (...ags)=>{
  updateUtilSubmit(...ags, ()=>{
    updateUtil['funItem'].close();
    store.dispatch('loginOutNoCheck');
    message('修改成功，请重新登录。', 1);
  })
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>
.user-info-popover{
  min-width: 0 !important;
  padding: 5px !important;
  // .el-button{
  //   // width: 60px;
  // }
  text-align: center;
  .user-name{
    color: var(--fontColor_22);
    font-family: OPPOSans-H;
    line-height: 20px;
    font-size: 15px;
    text-align: left;
  }
  .function-box{
    height: 60px;
    width: 240px;
    border-radius: var(--borderRadiusSize);
    background-color: var(--backgroundColor_21);
    margin: 8px 0;
    padding: 10px;
    cursor: pointer;

    display: flex;
    .svg-icon{
      width: calc(60px - 10px * 2);
      height: calc(60px - 10px * 2);
    }
    .function-name{
      line-height: calc(60px - 10px * 2);
      text-align: left;
      padding: 0 10px;
      color: var(--fontColor_23);
      font-family: OPPOSans-M;
      font-size: 15px;
    }
    .function-day{
      line-height: calc(60px - 10px * 2);
      color: var(--fontColor_24);
      font-family: OPPOSans-B;
      font-size: 15px;
      min-width: 0;
      flex: 1;
    }
  }
  .days-Remaining {
    font-size: 12px;
    font-weight: bold;
  }
  .days-Remaining {
    color: var(--fontCheckLightColor)
  }
}
</style>

<style lang='less' scoped>
.user-info-container{
  height: 40px;
  aspect-ratio: 1/1;
  border-radius: 10px;
  // &:hover{
  //   background-color: var(--el-menu-hover-bg-color);
  // }
  background-color: #fff;
  text-align: center;
  .svg-icon{
    height: 100%;
    width: 100%;
    cursor: pointer;
    outline: none;
  }
}
</style>